module.exports = __webpack_public_path__ + "static/img/CI.fabcfa53.png";